import type { z } from 'zod';
import { zs } from '@/entities/shared/schemas/zod';

export const repeatUnitSchema = zs.enum(['days', 'weeks', 'months', 'years']);

export type RepeatUnit = z.infer<typeof repeatUnitSchema>;
